import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props, union } from '@ngrx/store';
import {
  BtPayContext,
  PaymentAccount,
} from '@arc/unified-payments-frontend/shared-payment';

export const LoadAvailablePaymentAccounts = createAction(
  '[BtPay Payment Accounts] Load Available Payment Accounts',
  props<{
    buyerAccountIdentifier: string;
    btPayContext: BtPayContext;
    externalUserUrn: string;
  }>(),
);

export const LoadAvailablePaymentAccountsSuccess = createAction(
  '[BtPay Payment Accounts] Load Available Payment Accounts Success',
  props<{
    paymentAccounts: PaymentAccount[];
  }>(),
);

export const LoadAvailablePaymentAccountsFailure = createAction(
  '[BtPay Payment Accounts] Load Available Payment Accounts Failure',
  props<{
    error: HttpErrorResponse;
  }>(),
);

export const LoadAvailablePaymentAccountsAfterRedirectSuccess = createAction(
  '[BtPay Payment Accounts] Load Available Payment Accounts After Redirect Success',
  props<{
    paymentAccounts: PaymentAccount[];
  }>(),
);

export const LoadAvailablePaymentAccountsAfterRedirectFailure = createAction(
  '[BtPay Payment Accounts] Load Available Payment Accounts After Redirect Failure',
  props<{
    error: HttpErrorResponse;
  }>(),
);

const BtPayPaymentAccountsActions = union({
  LoadAvailablePaymentAccounts,
  LoadAvailablePaymentAccountsSuccess,
  LoadAvailablePaymentAccountsFailure,
});

export type BtPayPaymentAccountsActionsUnion =
  typeof BtPayPaymentAccountsActions;
